import React, { useState } from 'react';
import AxiosInstance from '../Axios/AxiosInstance';
import * as FaIcons from "react-icons/fa";
export const FileUploader = () => {
    //const [files, setFiles] = useState([]);
    const [files, setFiles] = useState([]);
    const [robotId, setRobotId] = useState('');
    const [plantId, setPlantId] = useState('');
    const [fileVersion, setFileVersion] = useState('');
    const [uploadedBy, setUploadedBy] = useState('Admin');
    //const [allowedFileType, setAllowedFileType] = useState('.py,ion,.hext.txt');// default or get from auth
    const [validityHours, setValidityHours] = useState(72);
    const [userId, setUserId] = useState(1);
    //const [latitude, setLatitude] = useState(null);
   // const [longitude, setLongitude] = useState(null);
    const handleFileChange = (e) => {
        setFiles(e.target.files);
    };
    const handleUpload = async () => {
        if (!files || !robotId || !plantId || !fileVersion) {
            alert('Please fill in all fields and select a file.');
            return;
        }
        var userID = sessionStorage.getItem("user_id");
        setUserId(userID);
        const formData = new FormData();
       // formData.append('file', files);
        for (let file of files) {
            formData.append("files", file);
        }
        formData.append('robotId', robotId);
        formData.append('plantId', plantId);
        formData.append('fileVersion', fileVersion);
        formData.append('uploadedBy', uploadedBy);
      //  formData.append('allowedFileType', "py");
        formData.append('validityHours', validityHours);
        formData.append('userId', userId);
       // formData.append('latitude', 18);
       // formData.append('longitude', 73);
        try {
            const response = await AxiosInstance.post('/File/upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            const { message, versionedFileName, token, expiresAt } = response.data;

            alert(
                `✅ ${message}\n\n📂 File: ${versionedFileName}\n🔐 Token: ${token}\n⏳ Expires: ${expiresAt}`
            );
        } catch (error) {
            const msg =
                error?.response?.data?.message || // if your API returns structured error
                error?.message ||
                "Unknown upload error";

            alert("❌ Upload failed: " + msg);
            console.error("Upload error:", error);
        }

    };

    return (
       
          <div className="container-ul">
            <div className="form-container">
                <h2 className="form-title"><FaIcons.FaRegEdit /> Upload Files(.py, .ino, .hex and .txt)</h2>
               
                <span className="form-message">
                   &nbsp;
                </span>

                <div>
                    <input type="file" multiple accept=".py,.ino" onChange={handleFileChange} /> <br /><br />
                    <input
                        type="text"
                        placeholder="Plant ID"
                        value={plantId}
                        onChange={(e) => setPlantId(e.target.value)}
                    /> <br />
                    <input
                        type="text"
                        placeholder="Robot ID"
                        value={robotId}
                        onChange={(e) => setRobotId(e.target.value)}
                    /> <br />
                   
                    <input
                        type="text"
                        placeholder="File Version (e.g. v1.0)"
                        value={fileVersion}
                        onChange={(e) => setFileVersion(e.target.value)}
                    /> <br /><br />
                    {/*<input*/}
                    {/*    type="text"*/}
                    {/*    placeholder="Uploaded By"*/}
                    {/*    value={uploadedBy}*/}
                    {/*    onChange={(e) => setUploadedBy(e.target.value)}*/}
                    {/*/> <br /><br />*/}
                    <button className="submit-button" onClick={handleUpload}>Upload</button>
                </div>
            </div>
        </div> 
    );
}
export default FileUploader;
